

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// approveCustomer
// APPROVECUSTOMER
const APPROVECUSTOMER= createAsyncThunk(
  "approveCustomer/approveCustomer",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveCustomerSlice = createSlice({
  name: "approveCustomerSlice",
  initialState: {
    approveCustomer: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveCustomer: (state) => {
        state.approveCustomer.loading = false
        state.approveCustomer.error = false
        state.approveCustomer.data = []
        state.approveCustomer.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVECUSTOMER.fulfilled, (state, action) => {
      state.approveCustomer = {
        ...state.approveCustomer,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVECUSTOMER.pending, (state, action) => {
      state.approveCustomer = {
        ...state.approveCustomer,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVECUSTOMER.rejected, (state, action) => {
      state.approveCustomer = {
        ...state.approveCustomer,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveCustomerAction = {
    APPROVECUSTOMER,
};

export { approveCustomerAction };
export default approveCustomerSlice.reducer;
export const {setInitialStateOfapproveCustomer} = approveCustomerSlice.actions